const images = {
    logo: require('~/logo.svg'),
    logolink: require('~/assets/images/AE6789.webp'),
    loading: require('~/assets/images/Loading.png'),
    btnvpns: require('~/assets/images/btn-vpns.png'),
};

export default images;
